import { render } from "./LessonProductModal.vue?vue&type=template&id=e07ba080"
import script from "./LessonProductModal.vue?vue&type=script&lang=js"
export * from "./LessonProductModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__